export enum DatadogEvents {
  PROCEED_TO_PAY = 'Click on Proceed to Pay',
  VISITED_EMPTY_COHORT = 'Visited empty cohort',
  ACCESS_DENIED = 'Access denied',
}
